export const formatSiteAddress = (address) => {
    if (!address) {
        return undefined;
    }
    const parts = [address.addressLine, address.city, address.region, address.postalCode]
        .map((part) => part?.trim())
        .filter((part) => Boolean(part));
    return parts.length > 0 ? parts.join(', ') : undefined;
};
export function toSite(site) {
    return {
        id: site.id,
        environmentId: site.environmentId,
        key: site.key,
        siteId: site.siteId,
        studyId: site.studyId,
        name: site.metadata.name,
        number: site.metadata.number,
        countryCode: site.metadata.address.countryCode,
        piName: site.metadata.principalInvestigator,
        addressDisplay: formatSiteAddress(site.metadata.address),
        siteLocales: site.metadata.siteLocales,
        participantLocales: site.metadata.participantLocales,
    };
}
export function toEnvironment(environment) {
    return {
        id: environment.id,
        name: environment.name,
        isProd: environment.deployment.isProd,
    };
}
